import { render, staticRenderFns } from "./AttendPage.vue?vue&type=template&id=bd9e8d74&lang=pug"
import script from "./AttendPage.vue?vue&type=script&lang=ts"
export * from "./AttendPage.vue?vue&type=script&lang=ts"
import style0 from "./AttendPage.vue?vue&type=style&index=0&id=bd9e8d74&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports